import React from 'react'
import { Modal } from 'react-bootstrap'
import styles from './EmptyModal.module.scss'
import { useTranslation } from 'react-i18next'
import Button from 'design-system/button'
import { ButtonSizes, ButtonVariant } from 'design-system/button/src/Button'

interface IEmptyModal {
  show: boolean
  className?: string
  title?: any
  text: any
  acceptButtonText?: string
  onAccept?: any
  onClose: any
  showButtons?: boolean
  twoButtons?: boolean
}

const EmptyModal: React.FC<IEmptyModal> = ({
  show,
  className = '',
  title = '',
  text,
  acceptButtonText = '',
  onAccept = undefined,
  onClose,
  twoButtons = true,
  showButtons = true,
}) => {
  const { t } = useTranslation()

  const handleOnAccept = () => {
    onAccept()
  }

  return (
    <Modal
      show={show}
      size="lg"
      centered
      className={`${styles.modalContainer} ${className}`}
      onHide={onClose}
    >
      <Modal.Header
        translate="yes"
        closeButton
        className={`${styles.modalHeader} d-flex align-items-center`}
      >
        <h1 className="title m-0">
          {title || t('components.modal.titles.info')}
        </h1>
      </Modal.Header>

      <Modal.Body className="px-4 py-4">
        <div className={styles.text}>{text}</div>
      </Modal.Body>
      {showButtons && (
        <>
          <div className="px-4 d-flex justify-content-center">
            <div className="dropdown-divider m-0 w-100 " />
          </div>
          <Modal.Footer className="border-0">
            {twoButtons && (
              <Button
                size={ButtonSizes.Small}
                variant={ButtonVariant.Secondary}
                className="my-0"
                onClick={onClose}
              >
                {t('components.modal.buttons.cancel')}
              </Button>
            )}
            <Button
              size={ButtonSizes.Small}
              variant={ButtonVariant.Primary}
              className="my-0"
              onClick={handleOnAccept}
            >
              {acceptButtonText || t('components.modal.buttons.accept')}
            </Button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  )
}

export default EmptyModal
